import { ReactNode } from 'react';
import { DoqType, LilInfoDoq } from '@ardoq/doq';
import { EmptyState, EmptyStateNotFoundIllustration } from '@ardoq/status-ui';

type ContentNotFoundStateProps = {
  contentType: string;
  title?: string;
  message?: ReactNode;
};

export const ContentNotFoundState = ({
  contentType,
  title = 'Component not found',
  message = (
    <>
      <div>We are sorry but your {contentType} could not be found.</div>
      <div>
        Please try again later or contact customer support if the issue
        persists.
      </div>
    </>
  ),
}: ContentNotFoundStateProps) => {
  return (
    <EmptyState
      layout="vertical"
      size="small"
      media={<EmptyStateNotFoundIllustration />}
      title={title}
      description={message}
    />
  );
};

type EmptySearchDoqProps = {
  contentType: string;
  title?: string;
  message?: ReactNode;
};

export const EmptySearchDoq = ({
  contentType,
  title = 'No results found',
  message = <div>No {contentType} matching your criteria could be found.</div>,
}: EmptySearchDoqProps) => {
  return (
    <LilInfoDoq doqType={DoqType.MISSING_ORG} message={message} title={title} />
  );
};
